import { useState } from "react";
import { Box, IconButton, Typography, Avatar, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "state";
import Navbar from "scenes/widgets/navbar";
import { resolveAssetUrl } from "utils/media";

const NavbarLogin = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const isDesktop = useMediaQuery("(min-width:900px)");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(setLogout());
    handleMenuClose();
    navigate("/einloggen");
  };

  return (
    <Box position="relative">
      <Navbar showMobileLoginOption />
      {isDesktop && (
        <Box
          sx={{
            position: "fixed",
            top: "28px",
            transform: "translateY(-50%)",
            right: "16px",
            zIndex: 1200,
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          {user ? (
            <>
              <IconButton onClick={handleMenuOpen}>
                <Avatar
                  src={resolveAssetUrl(user.picturePath)}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
                disableScrollLock
              >
                <MenuItem
                  onClick={() =>
                    navigate(user.username ? `/u/${user.username}` : `/profile/${user._id}`)
                  }
                >
                  Mein Profil
                </MenuItem>
                <MenuItem onClick={() => navigate("/konto")}>Konto</MenuItem>
                <MenuItem onClick={handleLogout}>Abmelden</MenuItem>
              </Menu>
            </>
          ) : (
            <Typography
              variant="h6"
              fontFamily="Montserrat"
              fontWeight="bold"
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/einloggen")}
            >
              Login
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default NavbarLogin;
